import { Button, Link, Stack, Typography } from '@mui/joy';

import { LogoutForm } from '@/components/authentication/LogoutForm';
import { User } from '@/modules/api';

type WaitingForApprovalProps = { user: User };

export function UserWaitingForApproval({ user }: WaitingForApprovalProps) {
  return (
    <Stack gap={2}>
      <Typography level="h1">Warten auf Freischaltung</Typography>
      <Typography level="title-lg">
        Willkommen {user.firstName} {user.lastName}
      </Typography>
      <Typography>
        Ihre Freischaltung wird durch die Administrator*innen oder Manager*innen ihrer Organisation geprüft. Bei Fragen
        kontaktieren Sie bitte{' '}
        <Link href="mailto:verkehrszeichenkataster@vm.bwl.de">verkehrszeichenkataster@vm.bwl.de</Link>.
      </Typography>

      <LogoutForm flex="1 0 0" marginTop={4}>
        <Button type="submit" variant="outlined" fullWidth>
          Logout
        </Button>
      </LogoutForm>
    </Stack>
  );
}
